import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

/**Local files */
import { orders } from '../utils/index';

@Injectable()
export class CommonQueryService {
  ordersValues = orders;

  public allOrderDetails: any;
  public GET_FIRST_ORDER_DETAILS: any;
  public GET_ALL_ORDER_DETAILS: any;
  public GET_NEXT_ORDER_DETAILS: any;
  public UPDATE_ORDER_DETAILS: any;
  public UPDATE_ORDER_DETAILS_BY_ID: any;
  public GET_ORDER_BY_ID: any;
  public GET_ORDER_BY_ID_SOL: any;
  public GET_ORDER_BY_ID_NEW: any;
  public GET_ALL_ARCHIVED_ORDERS: any;
  public GET_ALL_ARCHIVED_ORDERS_LIMIT: any;
  public GET_ALL_THE_ORDERS: any;
  public UPDATE_ORDER_NEW_FIELDS: any;
  public GET_FILTER_ORDER_DETAILS: any;
  public GET_STATUS_LIST_BY_ROLE_ID: any;
  public CREATE_CLAIM_ORDERS: any;
  public GET_CLAIM_ORDER_BY_ORDER: any;
  public DELETE_CLAIMED_ORDER_BY_ID: any;
  public GET_MENU_ITEMS_BY_ROLE_ID: any;
  public GET_MENU_ITEMS: any;
  public FETCH_MENU_BY_ROLE_PERMISSION: any;
  public CREATE_AUDIT_LOG: any;
  public LIST_AUDIT_LOG_BY_ORDER_ID: any;
  public GET_SEARCH_STR_ORDERID: any;
  public GET_SEARCH_STR_ORDERID_BY_ROLES: any;
  public GET_SEARCH_STR_ORDERS: any;
  public GET_STATUS_LIST_BY_USER_ID: any;
  public LIST_AUDIT_LOG: any;
  public LIST_ALL_USER_AUDIT_LOG: any;
  public LIST_ALL_ROLES_AUDIT: any;
  public LIST_ALL_STATUS_AUDIT: any;
  public LIST_ALL_MENU_AUDIT: any;
  public LIST_MARKET: any;
  public LIST_FIRM: any;
  public LIST_OFFICE: any;
  public GET_ORDER_FOR_SEARCH_ROLE_PERMISSIONS: any;
  public GET_ALL_ORDERS_CRM : any;
  public GET_ALL_ORDERS_CRM_WITH_PG : any;

public GET_ALL_ORDERS_CRM_BATCH: any;
public GET_ALL_ORDERS_CRM_FULL: any;
public GET_ALL_ORDERS_CRM_WITH_PAGINATION: any;
public GET_ALL_ORDERS_CRM_WITH_OFFSET: any;
public GET_ALL_ORDERS_CRM_LIGHT: any;

  public GET_FIRST_ORDER_DETAIL: any;
  public GET_NEXT_ORDER_DETAIL: any;

  constructor(public apollo: Apollo) {
    /*get all orders based on address*/
    this.allOrderDetails = gql`
      query GetOrders {
        allInspectionReportsSrcs(orderBy: ORDER_ID_DESC) {
          edges {
            node {
              id
              orderId
              insReportId
              reportReviewDetailsByInsReportId(first: 1) {
                edges {
                  node {
                    orderId
                    reviewId
                  }
                }
              }
              scheduleRequestByScheduleRequestId {
                id
                createdAt
                statusId
                statusChangeAt
                scheduleRequestDate
                userByAcceptedBy {
                  firstName
                  lastName
                  email
                }
              }
              solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                nodes{
                  roleid
                  roleByRoleid{
                    roleId
                    roleName
                  }
                  userByUserid {
                    userId
                    firstName
                  }
                  createdat
                }
              }

              reportSolutionMastersByInsReportId(first: 1) {
                nodes {
                  createdAt
                  id
                }
              }
            }
          }
        }
        # allOcrDumps(orderBy:ORDER_ID_DESC) {

        #     nodes {
        #         orderId
        #     }

        #  }
      }
    `;

    /*get all orders */
    this.GET_FIRST_ORDER_DETAILS = gql`
    query GetOrders($first:Int!) {
      allOrders(first:$first,orderBy: ORDERED_DATE_DESC,condition:{archive:null}){
        nodes{
           id
           nodeId
           archive
           orderContent
           orderedDate
           createdAt
            inspectionReportsSrcByOrderId {
                   id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    nodeId
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{
                      roleid
                      roleByRoleid{
                        roleId
                        roleName
                      }
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }

                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }



            }

              orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                    nodes {
                      orderId
                      statusId
                      statusByStatusId {
                        statusId
                        statusName
                      }
				      	}
				      }
        }
         pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
         totalCount
      }

    }

    `;

        this.GET_FIRST_ORDER_DETAIL = gql`
    query GetOrders($first:Int!) {
      allOrders(first:$first,orderBy: ORDERED_DATE_DESC,condition:{archive:null}){
        nodes{
           id
           nodeId
           archive
           orderContent
           orderedDate
           createdAt
           marketId
                  marketByMarketId{
                    marketName
                  }
                  firmId
                  firmByFirmId{
                    firmsName
                  }
                  officeByOfficeId{
                    officesName
                  }
            inspectionReportsSrcByOrderId {
                   id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    nodeId
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{
                      roleid
                      roleByRoleid{
                        roleId
                        roleName
                      }
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }



                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }



            }

              orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                    nodes {
                      orderId
                      statusId
                      statusByStatusId {
                        statusId
                        statusName
                      }
				      	}
				      }
        }
         pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
         totalCount
      }

    }

    `;

    /*get all orders */
    this.GET_ALL_ORDER_DETAILS = gql`
 query GetOrders($limit:Int,$offset:Int) {
   allOrders(first:$limit,offset:$offset,orderBy: ORDERED_DATE_DESC,condition:{archive:null}){
     nodes{
        id
        nodeId
        archive
        firstName
        lastName
        indrole
        firmByFirmId{
          firmsName
        }
        officeByOfficeId{
          officesName
        }
        marketByMarketId{
          marketName
        }
        orderContent
        orderedDate
        createdAt
         inspectionReportsSrcByOrderId {
                id
               orderId
               insReportId
               reportReviewDetailsByInsReportId(first: 1) {
                 edges {
                   node {
                     orderId
                     reviewId
                   }
                 }
               }
               scheduleRequestByScheduleRequestId {
                 id
                 createdAt
                 statusId
                 statusChangeAt
                 scheduleRequestDate
                 nodeId
                 userByAcceptedBy {
                   firstName
                   lastName
                   email
                 }
               }
               solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                 nodes{
                   roleid
                   roleByRoleid{
                     roleId
                     roleName
                   }
                   userByUserid {
                     userId
                     firstName
                     lastName
                   }
                   createdat
                 }
               }

               reportSolutionMastersByInsReportId(first: 1) {
                 nodes {
                   createdAt
                   id
                 }
               }
         }

           orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                 nodes {
                   orderId
                   statusId
                   statusByStatusId {
                     statusId
                     statusName
                   }
             }
           }
     }
      totalCount
   }
 }
 `;


    /*get all orders */
    this.GET_NEXT_ORDER_DETAILS = gql`
    query GetOrder($first:Int!,$cursor:Cursor!) {
    allOrders(after: $cursor,first:$first,orderBy: ORDERED_DATE_DESC,condition:{archive:null}){
        nodes{
          id
          nodeId
          archive
          orderContent
          orderedDate
          createdAt
            inspectionReportsSrcByOrderId {
                  id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{
                      roleid
                      roleByRoleid{
                        roleId
                        roleName
                      }
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }

                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }


            }

            orderStatusesByOrderId(orderBy:ID_DESC,first:1){
              nodes {
                orderId
                statusId
                statusByStatusId {
                  statusId
                  statusName
                }
              }
            }
        }
        pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
        totalCount
      }

    }
    `;

        this.GET_NEXT_ORDER_DETAIL = gql`
    query GetOrder($first:Int!,$cursor:Cursor!) {
    allOrders(after: $cursor,first:$first,orderBy: ORDERED_DATE_DESC,condition:{archive:null}){
        nodes{
          id
          nodeId
          archive
          orderContent
          orderedDate
          createdAt
                    marketId
                  marketByMarketId{
                    marketName
                  }
                  firmId
                  firmByFirmId{
                    firmsName
                  }
                  officeByOfficeId{
                    officesName
                  }
            inspectionReportsSrcByOrderId {
                  id
                  orderId
                  insReportId
                  reportReviewDetailsByInsReportId(first: 1) {
                    edges {
                      node {
                        orderId
                        reviewId
                      }
                    }
                  }
                  scheduleRequestByScheduleRequestId {
                    id
                    createdAt
                    statusId
                    statusChangeAt
                    scheduleRequestDate
                    userByAcceptedBy {
                      firstName
                      lastName
                      email
                    }
                  }
                  solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                    nodes{
                      roleid
                      roleByRoleid{
                        roleId
                        roleName
                      }
                      userByUserid {
                        userId
                        firstName
                        lastName
                      }
                      createdat
                    }
                  }

                  reportSolutionMastersByInsReportId(first: 1) {
                    nodes {
                      createdAt
                      id
                    }
                  }


            }

            orderStatusesByOrderId(orderBy:ID_DESC,first:1){
              nodes {
                orderId
                statusId
                statusByStatusId {
                  statusId
                  statusName
                }
              }
            }
        }
        pageInfo
        {
            startCursor
            endCursor
            hasNextPage
        }
        totalCount
      }

    }
    `;


    //Update KPI report  detail
    this.UPDATE_ORDER_DETAILS = gql`
    mutation updateOrder($input:UpdateOrderInput!) {

      updateOrder(input:$input) {
            order{
                  id
                  firstName
                  postcode
                  state
                  city
                  address
                  archive
                  editedAt
                  editedBy
                  indrole
                  marketId
                  marketByMarketId{
                    marketName
                  }
                  firmId
                  firmByFirmId{
                    firmsName
                  }
                  officeByOfficeId{
                    officesName
                  }
                }
            }
        }
    `;

    this.UPDATE_ORDER_DETAILS_BY_ID = gql`
    mutation updateOrder($input: UpdateOrderByIdInput!) {
      updateOrderById(input: $input) {
        order {
          id
          firstName
          postcode
          state
          city
          address
          archive
          editedAt
          editedBy

        }
      }
    }
    `;

    this.GET_ORDER_BY_ID = gql`
    query GetOrders($input:Int!) {
      allOrders(condition:{id:$input}) {
         nodes{
          id
          nodeId
          archive
          orderContent
          notes
          productId
          statusId
          latitude
          longitude
          createdAt
          duedate
          statusByStatusId{
            statusName
            displayStatus
          }
          couponId
          couponByCouponId{
            couponAmount
          }
          productId
          productByProductId{
            productId
            productName
            productPrice
            sku
          }
          contactName
          contactDate
          contactEmail
          contactPhone
          projectInfo
          haveMorePics
          orderStatusesByOrderId(orderBy:ID_DESC,first:1){
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
      }
  } `;

    this.GET_ORDER_BY_ID_SOL = gql`
    query GetOrders($input: Int!, $userId: UUID!, $roleId: UUID!) {
      allOrders(condition: {id: $input}) {
        nodes {
          id
          nodeId
          archive
          orderContent
          notes
          productId
          statusId
          statusByStatusId {
            statusName
            displayStatus
          }
          productByProductId {
            productId
            productName
            sku
          }
          contactName
          contactDate
          contactEmail
          contactPhone
          projectInfo
          haveMorePics
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}, userId: {equalTo: $userId}, roleId: {equalTo: $roleId}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus
              }
              roleByRoleId {
                roleName
              }
              userByUserId {
                firstName
                lastName
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
      }
    }`;

    this.GET_ALL_ORDERS_CRM = gql`
    query GetAllOrders {
      allOrders {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          statusId
          productId
          firmByFirmId {
            firmId
            firmsName
          }
          officeByOfficeId {
            officeId
            officesName
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          couponId
          couponByCouponId {
            couponId
            couponCode
            couponDesc
            couponAmount
            expireDate
          }
          marketByMarketId {
            marketId
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }`;


    this.GET_ALL_ORDERS_CRM_WITH_PG = gql`
    query GetAllOrdersWithPagination($first: Int, $after: Cursor) {
      allOrders(first: $first, after: $after) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          statusId
          productId
          firmByFirmId {
            firmId
            firmsName
          }
          officeByOfficeId {
            officeId
            officesName
          }
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          couponByCouponId {
            couponId
            couponCode
            couponDesc
            couponAmount
            expireDate
          }
          marketByMarketId {
            marketId
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }`;



     this.GET_ALL_ORDERS_CRM_BATCH = gql`
    query GetOrdersCRMBatch($first: Int!, $cursor: Cursor) {
      allOrders(
        first: $first, 
        after: $cursor, 
        orderBy: CREATED_AT_DESC, 
        condition: {archive: null}
      ) {
        nodes {
          id
          nodeId
          orderContent
          createdAt
          orderedDate
        }
          marketByMarketId {
  marketId
  marketName
}
firmByFirmId {
  firmId
  firmsName
}
officeByOfficeId {
  officeId
  officesName
}
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
        totalCount
      }
    }`;

  // CRM Full Query - All orders at once (use with caution)
  this.GET_ALL_ORDERS_CRM_FULL = gql`
    query GetAllOrdersCRMFull {
      allOrders(condition: {archive: null}, orderBy: CREATED_AT_DESC) {
        nodes {
          id
          nodeId
          orderContent
          createdAt
          orderedDate
        }
        totalCount
      }
    }`;

  // CRM Pagination Query - Cursor-based pagination
  this.GET_ALL_ORDERS_CRM_WITH_PAGINATION = gql`
    query GetOrdersCRMWithPagination($first: Int, $after: Cursor) {
      allOrders(
        first: $first, 
        after: $after, 
        orderBy: CREATED_AT_DESC, 
        condition: {archive: null}
      ) {
        nodes {
          id
          nodeId
          orderContent
          createdAt
          orderedDate
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }`;

  // CRM Offset Query - Limit/offset pagination
  this.GET_ALL_ORDERS_CRM_WITH_OFFSET = gql`
    query GetOrdersCRMWithOffset($limit: Int, $offset: Int) {
      allOrders(
        first: $limit, 
        offset: $offset, 
        orderBy: CREATED_AT_DESC, 
        condition: {archive: null}
      ) {
        nodes {
          id
          nodeId
          orderContent
          createdAt
          orderedDate
        }
        totalCount
      }
    }`;

  // CRM Light Query - Minimal fields for better performance
  this.GET_ALL_ORDERS_CRM_LIGHT = gql`
    query GetOrdersCRMLight($first: Int, $cursor: Cursor) {
      allOrders(
        first: $first, 
        after: $cursor, 
        orderBy: CREATED_AT_DESC, 
        condition: {archive: null}
      ) {
        nodes {
          id
          orderContent
          createdAt
        }
          marketByMarketId {
  marketId
  marketName
}
firmByFirmId {
  firmId
  firmsName
}
officeByOfficeId {
  officeId
  officesName
}
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }`;






    this.GET_ORDER_BY_ID_NEW = gql`
    query GetOrders($input:Int!) {
      allOrders(condition:{id:$input}) {
          nodes{
            id
            nodeId
            clientphone
            clientemail
            archive
            firstName
            lastName
            indrole
            statusId
            productId
            claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
              nodes {
                claimOrderId
                orderId
                statusId
                userId
                roleId
                statusByStatusId{
                  statusName
                  displayStatus
                }
                roleByRoleId {
                  roleName
                }
                userByUserId {
                  firstName
                  lastName
                }
              }
            }
            firmByFirmId{
              firmId
              firmsName
            }
            officeByOfficeId{
              officeId
              officesName
            }
            productId
            productByProductId{
              productId
              productName
              productPrice
              sku
            }
            couponId
            couponByCouponId{
              couponId
              couponCode
              couponDesc
              couponAmount
              expireDate
            }
            marketByMarketId{
              marketId
              marketName
            }
            orderContent
            orderedDate
            createdAt
             inspectionReportsSrcByOrderId {
                    id
                   orderId
                   insReportId
                   reportReviewDetailsByInsReportId(first: 1) {
                     edges {
                       node {
                         orderId
                         reviewId
                       }
                     }
                   }
                   scheduleRequestByScheduleRequestId {
                     id
                     createdAt
                     statusId
                     statusChangeAt
                     scheduleRequestDate
                     nodeId
                     userByAcceptedBy {
                       firstName
                       lastName
                       email
                     }
                   }
                   solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                     nodes{
                       roleid
                       roleByRoleid{
                         roleId
                         roleName
                       }
                       userByUserid {
                         userId
                         firstName
                         lastName
                       }
                       createdat
                     }
                   }

                   reportSolutionMastersByInsReportId(first: 1) {
                     nodes {
                       createdAt
                       id
                     }
                   }
             }

               orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                     nodes {
                       orderId
                       statusId
                       statusByStatusId {
                         statusId
                         statusName
                       }
                 }
               }
         }
          totalCount
       }
      }`;

    this.GET_STATUS_LIST_BY_ROLE_ID = gql`
    query RoleStatusPermission($roleId: UUID!) {
      allRoleStatusPermissions(filter: {roleId: {equalTo: $roleId}, isDeletedYn: {equalTo: false}}) {
        nodes {
          roleStatusPermissionId
          roleId
          statusId
          isDeletedYn
        }
      }
    }`;

    this.GET_STATUS_LIST_BY_USER_ID = gql`
    query RoleStatusPermission($userId: UUID!) {
      allUserStatusPermissions(filter: {userId: {equalTo: $userId}, isDeletedYn: {equalTo: false}}) {
        nodes {
          userStatusPermissionId
          userId
          statusId
          isDeletedYn

        }

      }
    }`;

    this.GET_ALL_ARCHIVED_ORDERS = gql`
    query GetOrders {
      allOrders(orderBy: ID_DESC, condition: {archive: "trash"}) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          statusId
          longitude
          latitude
          couponId
          couponByCouponId {
            couponAmount
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject

            }

          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus

              }
              roleByRoleId {
                roleName

              }
              userByUserId {
                firstName
                lastName

              }

            }

          }
          firmByFirmId {
            firmsName

          }
          officeByOfficeId {
            officesName

          }
          marketByMarketId {
            marketName

          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId

                }

              }

            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email

              }

            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName

                }
                userByUserid {
                  userId
                  firstName
                  lastName

                }
                createdat

              }

            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id

              }

            }

          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName

              }

            }

          }

        }
        totalCount

      }
    }`;

    this.GET_ALL_ARCHIVED_ORDERS_LIMIT = gql`
    query GetOrders($first: Int, $offset: Int) {
      allOrders(orderBy: ID_DESC, condition: {archive: "trash"}, offset: $offset, first: $first) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          statusId
          longitude
          latitude
          couponId
          couponByCouponId {
            couponAmount
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject

            }

          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus

              }
              roleByRoleId {
                roleName

              }
              userByUserId {
                firstName
                lastName

              }

            }

          }
          firmByFirmId {
            firmsName

          }
          officeByOfficeId {
            officesName

          }
          marketByMarketId {
            marketName

          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId

                }

              }

            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email

              }

            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName

                }
                userByUserid {
                  userId
                  firstName
                  lastName

                }
                createdat

              }

            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id

              }

            }

          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName

              }

            }

          }

        }
        totalCount

      }
    }`;

    this.GET_ALL_THE_ORDERS = gql`query GetOrders($first:Int,$offset:Int) {
      allOrders(offset:$offset, first:$first,orderBy: ID_DESC,) {
        nodes{
          id
          nodeId
          archive
          firstName
          lastName
          indrole
          couponId
          couponByCouponId{
            couponAmount
          }
          productId
          productByProductId{
            productId
            productName
            productPrice
            sku
          }
          firmByFirmId{
            firmsName
          }
          officeByOfficeId{
            officesName
          }
          marketByMarketId{
            marketName
          }
          orderContent
          orderedDate
          createdAt
           inspectionReportsSrcByOrderId {
                  id
                 orderId
                 insReportId
                 reportReviewDetailsByInsReportId(first: 1) {
                   edges {
                     node {
                       orderId
                       reviewId
                     }
                   }
                 }
                 scheduleRequestByScheduleRequestId {
                   id
                   createdAt
                   statusId
                   statusChangeAt
                   scheduleRequestDate
                   nodeId
                   userByAcceptedBy {
                     firstName
                     lastName
                     email
                   }
                 }
                 solutionestimateusersByReportid( orderBy:CREATEDAT_DESC){
                   nodes{
                     roleid
                     roleByRoleid{
                       roleId
                       roleName
                     }
                     userByUserid {
                       userId
                       firstName
                       lastName
                     }
                     createdat
                   }
                 }

                 reportSolutionMastersByInsReportId(first: 1) {
                   nodes {
                     createdAt
                     id
                   }
                 }
           }

             orderStatusesByOrderId(orderBy:ID_DESC,first:1){
                   nodes {
                     orderId
                     statusId
                     statusByStatusId {
                       statusId
                       statusName
                     }
               }
             }
       }
        totalCount
     }
   }`;

    this.UPDATE_ORDER_NEW_FIELDS = gql`mutation updateOrder($input: UpdateOrderByIdInput!){
      updateOrderById(input: $input){
        order{
          id
          editedAt
          editedBy
          firstName
          lastName
          city
          state
          postcode
          address
          homeinsurl
          ddraurl
          agentrole
          indrole
          productId
          supportReportUrl
          uniqueReportUrl
          statusId
        }
      }
    }`;

    /*get filter orders */
    this.GET_FILTER_ORDER_DETAILS = gql`
    query GetOrders($productId: Int, $id: Int,$orderedDate: Datetime,$duedate: Datetime) {
      allOrders(orderBy: ORDERED_DATE_DESC, condition: {archive: null}, filter: {productId: {equalTo: $productId}, id: {equalTo: $id}, orderedDate: {equalTo: $orderedDate}, duedate: {equalTo: $duedate}}) {
        nodes {
          id
          nodeId
          archive
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }

 `;

    this.CREATE_CLAIM_ORDERS = gql`mutation createClaimOrders($input: CreateClaimOrderInput!) {
      createClaimOrder(input: $input) {
        claimOrder {
          claimOrderId
          orderId
          statusId
          userId
          roleId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.GET_CLAIM_ORDER_BY_ORDER = gql`
    query ($statusId: Int!, $orderId: Int!) {
      allClaimOrders(filter: {statusId: {equalTo: $statusId}, orderId: {equalTo: $orderId}, isDeletedYn: {equalTo: false}}) {
        nodes {
          claimOrderId
          orderId
          statusId
          userId
          roleId
          roleByRoleId {
            roleName
          }
          userByUserId {
            firstName
            lastName
          }
        }
      }
    }`;

    this.DELETE_CLAIMED_ORDER_BY_ID = gql`
    mutation updateIsDeletedYnForClaimOrders($input: UpdateClaimOrderByClaimOrderIdInput!) {
      updateClaimOrderByClaimOrderId(input: $input) {
        claimOrder {
          claimOrderId
          orderId
          statusId
          roleId
          userId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.GET_MENU_ITEMS_BY_ROLE_ID = gql`
    query listMenuItems($roleId: UUID!, $userId: UUID!) {
      allMenuItems(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          menuItemId
          parentMenuItem
          menuItems
          title
          url
          isDeletedYn
          createdAt
          updatedAt
          roleScreenPermissonsByMenuItemId(filter: {isDeletedYn: {equalTo: false}, roleId: {equalTo: $roleId}}) {
            nodes {
              roleScreenPermissonId
              menuItemId
              roleId
              isDeletedYn
            }
          }
          userMenuPermissionsByMenuItemId(filter: {isDeletedYn: {equalTo: false}, userId: {equalTo: $userId}}){
            nodes{
              userMenuPermissionId
              userId
              menuItemId
              isDeletedYn
            }
          }
        }
      }
    }`;

    this.GET_MENU_ITEMS = gql`
    query listMenuItems {
      allMenuItems(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          menuItemId
          parentMenuItem
          menuItems
          title
          url
          isDeletedYn
          createdAt
          updatedAt
        }
      }
     }`;

    this.FETCH_MENU_BY_ROLE_PERMISSION = gql`
    query allMenuItems($roleId: UUID!, $path: String!, $userId: UUID!) {
      allMenuItems(filter: {path: {equalTo: $path}, isDeletedYn: {equalTo: false}}) {
        nodes {
          menuItems
          menuItemId
          parentMenuItem
          roleScreenPermissonsByMenuItemId(filter: {roleId: {equalTo: $roleId}, isDeletedYn: {equalTo: false}}) {
            nodes {
              menuItemId
              menuItemId
              roleId
            }
          }
          userMenuPermissionsByMenuItemId(filter: {userId: {equalTo: $userId}, isDeletedYn: {equalTo: false}}) {
            nodes {
              menuItemId
              userId
            }
          }
        }
      }
    }`;

    this.CREATE_AUDIT_LOG = gql`
        mutation createAuditLogs($input: CreateAuditLogInput!) {
          createAuditLog(input: $input) {
            auditLog {
              auditLogsId
              roleId
              userId
              orderId
              newData
              oldData
              auditType
              logsDesc
              platform
              status
              isDeletedYn
              createdAt
              updatedAt
            }
          }
        }`;

    this.LIST_AUDIT_LOG_BY_ORDER_ID = gql`query auditHistory($orderId: Int!, $eventType: [String!]) {
          allAuditLogs(filter: {auditType: {in: $eventType}, orderId: {equalTo: $orderId}, isDeletedYn: {equalTo: false}} , orderBy: AUDIT_LOGS_ID_DESC) {
            nodes {
              auditLogsId
              roleId
              userId
              orderId
              newData
              oldData
              auditType
              logsDesc
              platform
              status
              isDeletedYn
              createdAt
              updatedAt
              userByUserId{
                firstName
                lastName
              }
            }
          }
        }`;


    this.GET_SEARCH_STR_ORDERID = gql`
    query searchOrder($searchStr: String!, $unArchive: Boolean!) {
      searchOrdersNew(searchStr: $searchStr, filter: {archive: {isNull: $unArchive}}) {
        pageInfo {
          hasNextPage
        }
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          agentrole
          statusId
          longitude
          latitude
          couponId
          duedate
          couponByCouponId {
            couponAmount

          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku

          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject

            }

          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus

              }
              roleByRoleId {
                roleName

              }
              userByUserId {
                firstName
                lastName

              }

            }

          }
          firmByFirmId {
            firmsName

          }
          officeByOfficeId {
            officesName

          }
          marketByMarketId {
            marketName

          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId

                }

              }

            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email

              }

            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName

                }
                userByUserid {
                  userId
                  firstName
                  lastName

                }
                createdat

              }

            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id

              }

            }

          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName

              }

            }

          }

        }
        totalCount
      }
    }
    `;

    this.GET_SEARCH_STR_ORDERID_BY_ROLES = gql`
    query searchOrder($searchStr: String!, $statusIds: [Int!], $unArchive: Boolean!) {
      searchOrdersNew(searchStr: $searchStr, filter: {statusId: {in: $statusIds}, archive: {isNull: $unArchive}}) {
        pageInfo {
          hasNextPage
        }
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          agentrole
          statusId
          longitude
          latitude
          couponId
          duedate
          couponByCouponId {
            couponAmount

          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku

          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject

            }

          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus

              }
              roleByRoleId {
                roleName

              }
              userByUserId {
                firstName
                lastName

              }

            }

          }
          firmByFirmId {
            firmsName

          }
          officeByOfficeId {
            officesName

          }
          marketByMarketId {
            marketName

          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId

                }

              }

            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email

              }

            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName

                }
                userByUserid {
                  userId
                  firstName
                  lastName

                }
                createdat

              }

            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id

              }

            }

          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName

              }

            }

          }

        }
        totalCount
      }
    }
    `;

    this.GET_SEARCH_STR_ORDERS = gql`
    query GetOrders($ordersId: [Int!]) {
      allOrders(filter: {id: {in: $ordersId}},orderBy: ORDERED_DATE_DESC, condition: {archive: null}) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          statusId
          longitude
          latitude
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject
            }
          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus
              }
              roleByRoleId {
                roleName
              }
              userByUserId {
                firstName
                lastName
              }
            }
          }
          firmByFirmId {
            firmsName
          }
          officeByOfficeId {
            officesName
          }
          marketByMarketId {
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }`;


    this.LIST_AUDIT_LOG = gql`query auditHistory( $eventType: [String!]) {
      allAuditLogs(filter: {auditType: {in: $eventType}, isDeletedYn: {equalTo: false}} , orderBy: AUDIT_LOGS_ID_DESC) {
        nodes {
          auditLogsId
          roleId
          userId
          orderId
          newData
          oldData
          auditType
          logsDesc
          platform
          status
          isDeletedYn
          createdAt
          updatedAt
          userByUserId{
            firstName
            lastName
          }
        }
      }
    }`;

    this.LIST_ALL_USER_AUDIT_LOG = gql`query allUsers {
      allUsers {
        nodes {
          firstName
          lastName
          email
          userId
          roleId
          roleByRoleId {
            roleName
          }
        }
      }
    }
    `;
    this.LIST_MARKET = gql`
    query Markets($offset:Int,$limit:Int) {
      allMarkets(offset:$offset,first:$limit, filter: {isDeletedYn : {equalTo: false}}) {
        nodes {
          marketId
          marketName
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
    `;

    this.LIST_FIRM = gql`
    query MarketsMultiFirm($offset: Int, $limit: Int, $marketId: Int) {
      allMarketsMultiFirms(offset: $offset, first: $limit, filter: {isDeletedYn: {equalTo: false}, marketId: {equalTo: $marketId}}) {
        nodes {
          marketsMultiFirmsId
          marketId
          marketByMarketId {
            marketName
          }
          firmId
          firmByFirmId {
            firmsName
          }
        }
        totalCount
      }
    }
    `;

    this.LIST_OFFICE = gql`
    query FirmsMultiOffices($offset: Int, $limit: Int, $firmId: Int, $marketId: Int) {
      allFirmsMultiOffices(
        offset: $offset
        first: $limit
        filter: {isDeletedYn: {equalTo: false}, firmId: {equalTo: $firmId}, marketId: {equalTo: $marketId}}
      ) {
        nodes {
          firmsMultiOfficesId
          officeId
          firmId
          marketId
          officeByOfficeId {
            officeId
            officesName
          }
          firmId
          firmByFirmId {
            firmId
            firmsName
          }
          isDeletedYn
          createdat
          updatedat
        }
        totalCount
      }
    }
    `;

    this.LIST_ALL_ROLES_AUDIT = gql`query GetRoles {
      allRoles(filter: {roleDiv: {equalTo: true}}) {
        nodes {
          roleId
          roleName
          isDeletedYn
        }
      }
    }`;

    this.LIST_ALL_STATUS_AUDIT = gql`query allStatus {
      allStatuses {
        nodes {
          nodeId
          statusId
          statusName
          availableStatus
          displayStatus
        }
      }
    }`;

    this.LIST_ALL_MENU_AUDIT = gql`query allMenu{
      allMenuItems{
        nodes{
          nodeId
          menuItemId
          menuItems
          title
          url
          parentMenuItem
          path
          isDeletedYn
        }
      }
    }`;

    this.GET_ORDER_FOR_SEARCH_ROLE_PERMISSIONS = gql`
    query searchUsers($searchStr: String!) {
      searchUsers(searchStr: $searchStr) {
        pageInfo {
          hasNextPage
        }
        nodes {
          nodeId
          firstName
          lastName
          email
          userId
          roleId
          roleByRoleId {
            roleName
            __typename
          }
          address
          phoneNumber
          deleteUser
          isDeactivateYn
          __typename
        }
        totalCount
      }
    }
    `;

  }

  /*Get allocated & accepted orders*/
  GET_ORDERS(): any {
    return this.apollo.watchQuery({
      query: this.allOrderDetails,
      fetchPolicy: 'network-only',
    });
  }

  GET_ALL_ARCHIVED_ORDERSLIST() {
    return this.apollo.watchQuery({
      query: this.GET_ALL_ARCHIVED_ORDERS,
      fetchPolicy: 'network-only',
    });
  }


  GET_ALL_ARCHIVED_ORDERSLIST_LIMIT(payload) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_ARCHIVED_ORDERS_LIMIT,
      variables: payload,
      fetchPolicy: 'network-only',
    });
  }

  /*Get allocated & accepted orders*/
  GET_ALL_ORDERS(from, cursor): any {
    return this.apollo.watchQuery({
      query: (cursor == '') ? this.GET_FIRST_ORDER_DETAIL : this.GET_NEXT_ORDER_DETAIL,
      variables:
      {
        "first": from,
        "cursor": cursor
      },
      fetchPolicy: 'network-only',
    });
  }

  /*Get allocated & accepted orders*/
  GET_CLAIM_ORDERS_BY_STATUS(payload): any {
    return this.apollo.watchQuery({
      query: this.GET_CLAIM_ORDER_BY_ORDER,
      variables: payload,
      fetchPolicy: 'network-only',
    });
  }

  /*Get allocated & accepted orders*/
  GET_ALL_ORDERS_NEW(query, payload): any {
    return this.apollo.watchQuery({
      query: gql(query),
      variables: payload,
      fetchPolicy: 'network-only',
    });
  }

  UPDATE_ORDER(nodeId, archive) {

    let status = archive;
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS,
      variables: {
        "input": {
          "nodeId": nodeId,
          "orderPatch": {
            "archive": status
          }
        }
      },
      fetchPolicy: 'no-cache'
    })
  }

  UPDATE_ORDER_BY_ID(orderId, archive) {

    let status = archive;
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS_BY_ID,
      variables: {
        "input": {
          "id": orderId,
          "orderPatch": {
            "archive": status
          }
        }
      },
      fetchPolicy: 'no-cache'
    })
  }

  DELETE_CLAIMED_ORDER(id) {

    return this.apollo.mutate({
      mutation: this.DELETE_CLAIMED_ORDER_BY_ID,
      variables: {
        "input": {
          "claimOrderId": id,
          "claimOrderPatch": {
            "isDeletedYn": true
          }
        }
      },
      fetchPolicy: 'no-cache'
    })
  }

  CREATE_CLAIM_ORDERS_F(payload) {

    return this.apollo.mutate({
      mutation: this.CREATE_CLAIM_ORDERS,
      variables: {
        "input": {
          "claimOrder": payload
        }
      },
      fetchPolicy: 'no-cache'
    });

  }

  EDIT_ORDER(nodeId, userId, orderDetails, address, firstName, agentrole, clientphone, clientemail, indrole) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS,
      variables: {
        "input": {
          "nodeId": nodeId,
          "orderPatch": {
            "editedAt": new Date(),
            "editedBy": userId,
            "orderContent": orderDetails,
            "address": address,
            "firstName": firstName,
            "agentrole": agentrole,
            "clientphone": clientphone,
            "clientemail": clientemail,
            "indrole": indrole
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  /*Get allocated & accepted orders*/
  FETCH_ORDER_BY_ID(id): any {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_ID,
      variables: {
        "input": Number.parseInt(id)
      },
      fetchPolicy: 'network-only',
    });
  }

  /*Get allocated & accepted orders*/
  FETCH_ORDER_BY_ID_FUN(id, userId, roleId): any {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_ID_SOL,
      variables: {
        "input": Number.parseInt(id),
        userId: userId,
        roleId: roleId,
      },
      fetchPolicy: 'network-only',
    });
  }

    getAllOrdersCRM() {
    return new Promise((resolve, reject) => {
      this.apollo.watchQuery({
        query: this.GET_ALL_ORDERS,
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      }).valueChanges.subscribe((response: any) => {
        resolve(response);
      }, (error) => {
        console.error('Error fetching all orders:', error);
        reject(error);
      });
    });
  }

    getAllOrdersWithPagination(first: number = 50, after: string = null) {
    return new Promise((resolve, reject) => {
      this.apollo.watchQuery({
        query: this.GET_ALL_ORDERS_CRM_WITH_PG,
        variables: {
          first: first,
          after: after
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
      }).valueChanges.subscribe((response: any) => {
        resolve(response);
      }, (error) => {
        console.error('Error fetching orders with pagination:', error);
        reject(error);
      });
    });
  }


//------------------------------------------------------------------------

  GET_ALL_ORDERS_CRM_BATCHS(batchSize: number = 50, cursor: string = '') {
  const variables: any = { first: batchSize };
  if (cursor && cursor !== '') {
    variables.cursor = cursor;
  }

  return this.apollo.watchQuery({
    query: this.GET_ALL_ORDERS_CRM_BATCH,
    variables: variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  });
}

/**
 * Get all orders for CRM (full query)
 */
GET_ALL_ORDERS_CRM_FULLS() {
  return this.apollo.watchQuery({
    query: this.GET_ALL_ORDERS_CRM_FULL,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  });
}

/**
 * Get orders with pagination for CRM
 */
GET_ALL_ORDERS_CRM_WITH_PAGINATIONS(first: number = 50, after: string = null) {
  const variables: any = { first: first };
  if (after) {
    variables.after = after;
  }

  return this.apollo.watchQuery({
    query: this.GET_ALL_ORDERS_CRM_WITH_PAGINATION,
    variables: variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  });
}

/**
 * Get CRM orders with limit/offset pagination
 */
GET_ALL_ORDERS_CRM_WITH_OFFSETS(limit: number = 50, offset: number = 0) {
  return this.apollo.watchQuery({
    query: this.GET_ALL_ORDERS_CRM_WITH_OFFSET,
    variables: {
      limit: limit,
      offset: offset
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  });
}

/**
 * Get lightweight CRM orders
 */
GET_ALL_ORDERS_CRM_LIGHTS(first: number = 100, cursor: string = null) {
  const variables: any = { first: first };
  if (cursor) {
    variables.cursor = cursor;
  }

  return this.apollo.watchQuery({
    query: this.GET_ALL_ORDERS_CRM_LIGHT,
    variables: variables,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  });
}

  /*Get allocated & accepted orders*/
  FETCH_ORDER_BY_ID_NEW(id): any {
    return this.apollo.watchQuery({
      query: this.GET_ORDER_BY_ID_NEW,
      variables: {

        "input": Number.parseInt(id)

      },
      fetchPolicy: 'network-only',
    });
  }

  /*Get allocated & accepted orders*/
  GET_STATUS_ID_BY_ROLE_ID(roleId): any {
    return this.apollo.watchQuery({
      query: this.GET_STATUS_LIST_BY_ROLE_ID,
      variables: {

        "roleId": roleId

      },
      fetchPolicy: 'network-only',
    });
  }

  GET_STATUS_ID_BY_USER_ID(userId): any {
    return this.apollo.watchQuery({
      query: this.GET_STATUS_LIST_BY_USER_ID,
      variables: {

        "userId": userId

      },
      fetchPolicy: 'network-only',
    });
  }


  EDIT_ORDER_NEW_FIELDS(nodeId, orderDetails) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_NEW_FIELDS,
      variables: {
        "input": {
          "id": nodeId,
          "orderPatch": orderDetails
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  GET_ALL_ORDERS_DB(payload) {
    return this.apollo.query({
      query: this.GET_ALL_THE_ORDERS,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  GET_FILTER_ORDERS(query, payload): any {
    return this.apollo.watchQuery({
      query: gql(query),
      variables: payload,
      fetchPolicy: 'network-only',
    });
  }

  GET_MENU_ITEMS_BY_ID_CALL(roleId, userId) {
    return this.apollo
      .watchQuery({
        query: this.GET_MENU_ITEMS_BY_ROLE_ID,
        variables: {
          roleId: roleId,
          userId: userId
        },
        fetchPolicy: 'network-only'
      });
  }

  GET_MENU_ITEMS_CALL() {
    return this.apollo
      .watchQuery({
        query: this.GET_MENU_ITEMS,
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_ORDER_FOR_SEARCH(searchStr, unArchive) {
    return this.apollo
      .watchQuery({
        query: this.GET_SEARCH_STR_ORDERID,
        variables: {
          searchStr: searchStr,
          unArchive: unArchive
        },
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_ORDER_FOR_SEARCH_BY_ROLES(searchStr, statusIds, unArchive) {
    return this.apollo
      .watchQuery({
        query: this.GET_SEARCH_STR_ORDERID_BY_ROLES,
        variables: {
          searchStr: searchStr,
          statusIds: statusIds,
          unArchive: unArchive
        },
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_ORDERS_FOR_SEARCH(ordersId) {
    return this.apollo
      .watchQuery({
        query: this.GET_SEARCH_STR_ORDERS,
        variables: {
          ordersId: ordersId
        },
        fetchPolicy: 'network-only'
      });
  }

  FETCH_MENU_BY_ROLE_PERMISSION_CALL(roleId, path, userId) {
    return this.apollo
      .watchQuery({
        query: this.FETCH_MENU_BY_ROLE_PERMISSION,
        variables: {
          roleId: roleId,
          path: path,
          userId: userId
        },
        fetchPolicy: 'network-only'
      });
  }

  CREATE_AUDIT_LOG_CALL(payload) {
    return this.apollo.mutate({
      mutation: this.CREATE_AUDIT_LOG,
      variables: {
        "input": {
          auditLog: payload
        }
      },
      fetchPolicy: 'no-cache'
    })
  }

  GET_AUDIT_HISTORY_BY_ORDER_ID(orderId, eventType) {
    return this.apollo
      .watchQuery({
        query: this.LIST_AUDIT_LOG_BY_ORDER_ID,
        variables: {
          orderId: orderId,
          eventType: eventType
        },
        fetchPolicy: 'network-only'
      });
  }

  EDIT_ORDERS(nodeId, updatePaylaod) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ORDER_DETAILS,
      variables: {
        "input": {
          "nodeId": nodeId,
          "orderPatch": updatePaylaod
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  GET_AUDIT_HISTORY(eventType) {
    return this.apollo
      .watchQuery({
        query: this.LIST_AUDIT_LOG,
        variables: {
          eventType: eventType
        },
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_USER_FOR_AUDIT_HISTORY() {
    return this.apollo
      .query({
        query: this.LIST_ALL_USER_AUDIT_LOG,
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_ROLES_FOR_AUDIT_HISTORY() {
    return this.apollo
      .query({
        query: this.LIST_ALL_ROLES_AUDIT,
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_STATUS_FOR_AUDIT_HISTORY() {
    return this.apollo
      .query({
        query: this.LIST_ALL_STATUS_AUDIT,
        fetchPolicy: 'network-only'
      });
  }

  GET_ALL_MENU_FOR_AUDIT_HISTORY() {
    return this.apollo
      .query({
        query: this.LIST_ALL_MENU_AUDIT,
        fetchPolicy: 'network-only'
      });
  }

  LIST_MARKETS(payload) {
    return this.apollo
      .watchQuery({
        query: this.LIST_MARKET,
        variables: payload,
        fetchPolicy: 'network-only'
      });
  }
  LIST_FIRMS(payload) {
    return this.apollo
      .watchQuery({
        query: this.LIST_FIRM,
        variables: payload,
        fetchPolicy: 'network-only'
      });
  }
  LIST_OFFICES(payload) {
    return this.apollo
      .watchQuery({
        query: this.LIST_OFFICE,
        variables: payload,
        fetchPolicy: 'network-only'
      });
  }

  GET_ORDER_FOR_SEARCH(searchStr) {
    return this.apollo
      .watchQuery({
        query: this.GET_ORDER_FOR_SEARCH_ROLE_PERMISSIONS,
        variables: {
          searchStr: searchStr
        },
        fetchPolicy: 'network-only'
      });
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/commonQuery.ts